import SignUpImage from "../../../assets/images/sign-up.png";

interface SplitScreenLayoutProps {
  children: React.ReactNode;
  contentClassName?: string;
}

export default function SplitScreenLayout({
  children,
  contentClassName = "",
}: SplitScreenLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col lg:flex-row">
      {/* Left Column - Dashboard Preview Image */}
      <div className="hidden lg:flex lg:w-1/2 xl:w-[45%] lg:items-center lg:justify-center lg:px-8 xl:px-14 lg:py-8">
        <div className="w-full max-w-2xl">
          <img
            src={SignUpImage}
            alt="Dashboard Preview"
            className="w-full h-auto object-contain"
          />
        </div>
      </div>

      {/* Right Column - Content */}
      <div
        className={`flex-1 flex items-center justify-center px-4 py-8 sm:px-6 md:px-8 lg:px-12 ${contentClassName}`}
      >
        {children}
      </div>
    </div>
  );
}
